/**
 * usePublicTheme — forces the default (ServiceSell PRO) colour theme on
 * public marketing pages even if a white-label brand is active in
 * localStorage from a logged-in session. On unmount the previous theme is
 * restored so the dashboard goes back to the dealer's branded look.
 *
 * Used by LandingPage, PilotPage, TheProcessPage. The white-label demo
 * (RRG / Toyota colour-swap) is strictly post-login per Steve's pitch flow.
 */
import { useEffect } from "react";
import { getActiveBrandKey } from "@/lib/brandProfile";

export function usePublicTheme() {
  useEffect(() => {
    const previous = document.documentElement.getAttribute("data-theme");
    // Force vanilla SSP for the duration of this page
    document.documentElement.removeAttribute("data-theme");
    return () => {
      // Restore the active brand's theme on unmount (navigate to dashboard)
      const activeKey = getActiveBrandKey();
      if (activeKey === "rrg") {
        document.documentElement.setAttribute("data-theme", "rrg");
      } else if (activeKey === "toyota") {
        document.documentElement.setAttribute("data-theme", "toyota");
      } else if (previous) {
        // Respect whatever the user had before (e.g. a ssp_brand_theme value)
        document.documentElement.setAttribute("data-theme", previous);
      }
    };
  }, []);
}
